<template>
  <div class="card">
    <div class="card-header">
      <div class="text-center">
        <div
          class="font-size-18 mb-3 d-flex align-items-center justify-content-center"
        >
          <img
            src="/resources/images/logos/EdStudent_small.png"
            alt="EdStudent Logo"
            class="app-logo me-3"
          />
          <span>EdStudent</span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <a-divider class="m-0">{{ $t("profil.nomUser") }}:</a-divider>
      <p class="text-gray-5 mb-2">
        {{ userName }}
      </p>
      <a-divider>{{ $t("profil.mdp") }}:</a-divider>
      <a-button-group class="d-flex justify-content-center">
        <a-button @click="showModal"> {{ $t("action.modifier") }} </a-button>
        <a-popconfirm
          :title="$t('sms.alertNumberSMS')"
          :ok-text="$t('action.confirmer')"
          :cancel-text="$t('action.annuler')"
          @confirm="() => sendSmsLoginToParent()"
        >
          <a-button
            v-if="studentSMSAccess"
            type="primary"
            :loading="loadingSms"
            :disabled="loadingSms"
            :class="{
              disabledPack: !btnAccessGetter.includes('sendLoginSms'),
            }"
          >
            {{ $t("menu.envoyerSms") }}
          </a-button>
        </a-popconfirm>
      </a-button-group>
    </div>
    <a-modal
      v-model="visible"
      :title="$t('profil.changerPrametreEleve')"
      width="60%"
      :ok-button-props="{
        props: { disabled: hasErrors(form.getFieldsError()) },
      }"
    >
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">{{ $t("profil.changerNomUtilisateur") }}</p>
              <a-form
                layout="inline"
                :form="form"
                @submit="handleUserNameChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="userNameError() ? 'error' : ''"
                  :help="userNameError() || ''"
                  style="width: 100%"
                >
                  <a-input
                    style="width: 100%"
                    v-decorator="[
                      'userName',
                      {
                        initialValue: userName,
                        rules: [
                          {
                            required: true,
                            message: $t('requis.username'),
                          },
                          {
                            validator: validateNoWhitespace,
                            message: $t('requis.noWhitespace'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.nomUser')"
                  >
                    <a-icon
                      slot="prefix"
                      type="user"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-4"
                  @click="handleUserNameChange"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            :class="
              status == 'inactive'
                ? 'card border-danger mb-3'
                : 'card border-success mb-3'
            "
          >
            <div class="card-header text-dark">
              {{ $t("studentCredentials.deactivateOrActivateAccount") }}
            </div>
            <div class="card-body">
              <p class="card-text">
                <a-tag :color="status == 'inactive' ? 'red' : 'green'">
                  {{
                    status == "active"
                      ? $t("studentCredentials.accountActivated")
                      : $t("studentCredentials.accountDeactivated")
                  }}
                </a-tag>
              </p>

              <a-button
                type="primary"
                @click="changeStatus"
                :loading="statusBtnLoading"
                :disabled="statusBtnLoading"
                >{{
                  status == "active"
                    ? $t("studentCredentials.deactivate")
                    : $t("studentCredentials.activate")
                }}</a-button
              >
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("profil.resetPwd") }}
              </p>
              <a-form
                layout="inline"
                :form="passwordForm"
                @submit="handlePasswordChange"
                class="login-form"
                style="width: 100%"
              >
                <a-form-item
                  :validate-status="passwordError() ? 'error' : ''"
                  :help="passwordError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'password',
                      {
                        rules: [
                          {
                            validator: validateStrongPassword,
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.NewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-form-item
                  :validate-status="passworConfirmdError() ? 'error' : ''"
                  :help="passworConfirmdError() || ''"
                  style="width: 100%"
                >
                  <a-input-password
                    v-decorator="[
                      'confirmPassword',
                      {
                        rules: [
                          {
                            validator: validatePass2,
                            message: $t('requis.confirmation'),
                          },
                        ],
                      },
                    ]"
                    :placeholder="$t('profil.ConfirmNewPwd')"
                  >
                    <a-icon
                      slot="prefix"
                      type="lock"
                      style="color: rgba(0, 0, 0, 0.25)"
                    />
                  </a-input-password>
                </a-form-item>
                <a-button
                  type="primary"
                  class="mt-2"
                  @click="handlePasswordChange"
                  :loading="loading"
                  :disabled="loading"
                  >{{ $t("action.enregistrer") }}</a-button
                >
              </a-form>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <p class="text-dark">
                {{ $t("studentCredentials.studentQrCode") }}
              </p>
              <vue-qr
                :text="qrData"
                :logoSrc="getBuilding.logo"
                :callback="getQrImage"
                qid="student"
              ></vue-qr>
              <a-button type="primary" class="mt-2" @click="ImprimerQr">{{
                $t("action.imprimer")
              }}</a-button>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <a-button key="back" @click="handleCancel">
          {{ $t("action.retour") }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapActions, mapGetters } from "vuex";
import VueQr from "vue-qr";
const { generateLoginPdf } = require("@/utilities/pdfLogin");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}
export default {
  name: "controlParentale",
  computed: {
    ...mapState(["settings"]),
    ...mapGetters("settings", ["btnAccessGetter"]),
    getBuilding() {
      return (
        this.settings.image.filter(
          (img) => img.db == this.settings.activeBuilding
        )[0] || {}
      );
    },
    qrData() {
      if (this.loginHash) {
        return window.btoa(this.loginHash + "#" + this.settings.base_url);
      }
      return "";
    },
  },
  components: {
    VueQr,
  },
  props: {
    idStudent: {
      required: false,
    },
    userName: {
      required: false,
    },
    phone: {
      required: false,
    },
    status: {
      required: false,
    },
    loginHash: {
      required: false,
    },
  },
  methods: {
    ImprimerQr() {
      let parentCred = {
        userName: this.userName,
      };
      this.generatePdf(parentCred);
    },
    handleCancel() {
      this.visible = false;
      this.form.resetFields();
      this.passwordForm.resetFields();
    },
    validateNoWhitespace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error(this.$t("studentCredentials.usernameNoWhitespace")));
      } else {
        callback();
      }
    },
    validateStrongPassword(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t("requis.mdp")));
      } else if (value == this.userName) {
        callback(new Error(this.$t("profil.passwordMustNotMatchUsername")));
      } else if (value.length < 8) {
        callback(new Error(this.$t("profil.passwordMinLength")));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeUppercase")));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeLowercase")));
      } else if (!/[0-9]/.test(value)) {
        callback(new Error(this.$t("profil.passwordMustIncludeDigit")));
      } else {
        callback();
      }
    },

    validatePass2(rule, value, callback) {
      if (value === "") {
        callback(
          new Error(this.$t("studentCredentials.passwordConfirmationRequired"))
        );
      } else if (value !== this.passwordForm.getFieldValue("password")) {
        callback(new Error(this.$t("studentCredentials.passwordMismatch")));
      } else {
        callback();
      }
    },
    showModal() {
      this.visible = true;
    },
    getQrImage(dataUrl) {
      this.qrDataImage = dataUrl;
    },
    handleOk(e) {
      this.visible = false;
    },
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("password");
    },
    passworConfirmdError() {
      const { getFieldError, isFieldTouched } = this.passwordForm;
      return getFieldError("confirmPassword");
    },
    changeStatus() {
      this.statusBtnLoading = true;

      let newStatus = this.status == "active" ? "inactive" : "active";
      apiClient
        .patch("/lms/student/" + this.idStudent, {
          data: { status: newStatus },
        })
        .then(async ({ data }) => {
          this.status = newStatus;
          this.$message.success(
            this.$t("studentCredentials.statusChangeSuccess")
          );
        })
        .catch((e) => {
          this.$message.error(this.$t("changementNonEffectue"));
        })
        .finally(() => {
          this.statusBtnLoading = false;
        });
    },
    handleUserNameChange(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) console.log(err);
        else {
          this.loading = true;
          apiClient
            .patch("/lms/student/username/" + this.idStudent, values)
            .then(async () => {
              this.userName = values.userName;
              this.$message.success(this.$t("success.eleveMSA"));
              this.generatePdf(values);
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.loading = false;
              this.visible = false;
              this.form.resetFields();
            });
        }
      });
    },
    handlePasswordChange(e) {
      e.preventDefault();
      this.passwordForm.validateFields((err, values) => {
        if (err) {
          console.log(err);
        } else {
          this.loading = true;
          apiClient
            .patch("/lms/student/password/" + this.idStudent, values)
            .then(async () => {
              this.$message.success(this.$t("success.eleveMSA"));
              this.generatePdf(values, true);
            })
            .catch((e) => {
              this.$message.error(e.response.data.error.message);
            })
            .finally(() => {
              this.loading = false;
              this.visible = false;
              this.passwordForm.resetFields();
            });
        }
      });
    },
    generatePdf(values, withPwd = false) {
      generateLoginPdf({
        userName: values.userName || this.userName,
        password: values.password || "",
        withPwd,
        settings: this.settings,
        qrDataImage: this.qrDataImage,
        userType: "student",
        t: this.$t.bind(this),
        locale: this.$i18n.locale,
      });
    },
    ...mapActions("settings", ["packHasBtnAccess"]),
    async sendSmsLoginToParent() {
      return; // temporary deactivate this for student until confirmation
      if (!(await this.packHasBtnAccess("sendLoginSms"))) return;

      //this.loadingSms = true;
      let parent = {
        _id: this.idStudent,
        userName: this.userName,
        pp: btoa(this.pwd),
        father: { phone: this.phones.father },
        mother: { phone: this.phones.mother },
      };
      apiClient
        .put("/sms/loginparents", {
          target: ["father", "mother"],
          customNumbers: "",
          total: 2,
          tags: ["Logins parents"],
          parents: [parent],
        })
        .then((res) => {
          this.$message.success(this.$t("studentCredentials.smsSentSuccess"));
        })
        .catch((e) => {
          console.log(e);
          switch (e.response.status) {
            case 401:
              this.$message.warning(e.response.data.message);

              break;

            default:
              this.$message.error(e.response.data.message);

              break;
          }
        })
        .finally(() => (this.loadingSms = false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
      this.passwordForm.validateFields();
    });
  },
  data() {
    return {
      studentSMSAccess: false,
      loadingSms: false,
      visible: false,
      hasErrors,
      qrDataImage: "",
      statusBtnLoading: false,
      form: this.$form.createForm(this, { name: "parent_login" }),
      passwordForm: this.$form.createForm(this, { name: "parent_passwords" }),
      loading: false,
    };
  },
};
</script>
<style>
.login-form .ant-col {
  width: 100% !important;
}

.fixed-height {
  height: 190px;
  /* Set your desired fixed height */
}

.app-logo {
  height: 38px;
  width: auto;
  margin-right: 10px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  border-radius: 6px;
  padding: 2px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
</style>
